export function isElectronRxProfileEmail(email) {
  const normalizedEmail = String(email || "")
    .trim()
    .toLowerCase();

  return (
    normalizedEmail.endsWith("@electronrx.com") ||
    normalizedEmail.endsWith("@benwjd.com")
  );
}
